import { AddOnKeys } from "./types";
import { ProductTypes } from "@components/Data/enums";

export const getIndividualPolicyTenurePrice = ({
  age,
  basePremium = 0,
  costSharing = 0,
  addOns = [],
  tenure,
}: {
  age: number;
  basePremium: number;
  costSharing: number;
  addOns: any;
  tenure: number;
}) => {
  basePremium = Number(basePremium);
  let priceAfterCostSharing = basePremium * (1 + costSharing / 100);
  let priceAfterPed = priceAfterCostSharing;
  const pedIndex = addOns.findIndex((addOn) => addOn.key == AddOnKeys.PED);
  if (pedIndex != -1) {
    priceAfterPed =
      basePremium * (1 - addOns[pedIndex].percentageValues[age] / 100);
  }
  let modifiedBasePremium = priceAfterPed;
  let totalAddOns = 0;
  for (const addOn of addOns) {
    const price =
      addOn?.prices && tenure in addOn.prices ? addOn.prices[tenure] : 0;
    if (
      [
        AddOnKeys.ROOM_MODIFICATION,
        AddOnKeys.DEDUCTIBLES,
        AddOnKeys.COPAYMENT,
        AddOnKeys.PPN,
        AddOnKeys.TIERED_NETWORK
      ].includes(addOn.key)
    ) {
      modifiedBasePremium *=
        1 - (addOn?.percentageValue || (addOn?.percentageValues&&addOn?.percentageValues[age])) / 100;
    } else if (
      ![
        AddOnKeys.FAST_FORWARD,
        AddOnKeys.PED,
        AddOnKeys.INTERNATIONAL_COPAYMENT,
        AddOnKeys.ACCUMALATE,
        AddOnKeys.OPD,
        AddOnKeys.PA_COMBO,
      ].includes(addOn.key)
    ) {
      totalAddOns += price;
    }
  }
  return {
    basePremium,
    priceAfterCostSharing,
    priceAfterPed,
    modifiedBasePremium,
    totalAddOns,
  };
};

export const SiLabels = {
  "100000": { label: "1L", stat: "49%" },
  "200000": { label: "2L", stat: "49%" },
  "300000": { label: "3L", stat: "49%" },
  "400000": { label: "4L", stat: "49%" },
  "500000": { label: "5L", stat: "49%" },
  "750000": { label: "7.5L", stat: "76%" },
  "1000000": { label: "10L", stat: "87%" },
  "1250000": { label: "12.5L", stat: "97%" },
  "1500000": { label: "15L", stat: "93%" },
  "2000000": { label: "20L", stat: "97%" },
  "3000000": { label: "30L", stat: "97%" },
  "2500000": { label: "25L", stat: "98%" },
  "4000000": { label: "40L", stat: "99%" },
  "4500000": { label: "45L", stat: "99%" },
  "5000000": { label: "50L", stat: "99%" },
  "6500000": { label: "65L", stat: "99%" },
  "7000000": { label: "70L", stat: "99%" },
  "7500000": { label: "75L", stat: "99%" },
  "9000000": { label: "90L", stat: "89%" },
  "9500000": { label: "95L", stat: "89%" },
  "10000000": { label: "1CR", stat: "100%" },
  "20000000": { label: "2CR", stat: "100%" },
  "30000000": { label: "3CR", stat: "100%" },
};

export const defaultCountry = {
  ISD: "+91",
  country: "India",
  maximum: "10",
  minimum: "10",
};

export const getQuoteStaticDefaultCountry = {
  country: "UAE (United Arab Emirates)",
  ISD: "+971",
  minimum: "4",
  maximum: "20"
};

export interface IsdsCountry {
  country: string
  ISD: string
  minimum: string
  maximum: string
}

export const productOneLiners = {
  [ProductTypes.REASSUREV2]:
    "Health Insurance Coverage that keeps rewarding you, Forever!!",
  [ProductTypes.HEALTH_RECHARGE]:
    "Go to the extra mile for your loved ones.",
  [ProductTypes.SENIOR_FIRST]:
    "Our best selling health insurance plan. 250k families trust this plan.",
  [ProductTypes.ASPIRE]:
    "Health Insurance Coverage that rewards you for starting young!!!",
  [ProductTypes.BHARAT]:
    `Plan that works your way and "Returns" more than it asks for.`,
  [ProductTypes.GO_ACTIVE]:
    `An active health insurance that works for you every day.`
};

export const planInfoButtonContent = {
  [ProductTypes.REASSUREV2]: `Pay premium as per your entry age, until a claim is paid by opting for Titanium+ or Platinum+ Variant
  Also, Carry Forward any used base sum insured in your policy 
  -	up to 10X for Titanium+ / Gold
  -	up to 5X for Platinum+
  -	up to 3X for Bronze+ / Bronze
  `,
  [ProductTypes.SENIOR_FIRST]:
    "We have two variants of this plan. The Gold plan is the basic plan and the Platinum plan is our premium plan with additional features such as ReAssure benefit, free health checkup, etc.",
  [ProductTypes.ASPIRE]: `From Gold+ to Titanium+ Respectively:\n
  Maximum Booster+ limits 3/5/10/10X\n
  M-iracle Waiting Period: 48/24/9/9 months\n 
  Pre-Existing Waiting Period: 48/36/36/36 months\n`,
  [ProductTypes.ASPIRE_SAVER]: `Aspire: \n
  From Gold+ to Titanium+ Respectively:\n
  Maximum Booster+ limits 3/5/10/10X\n
  M-iracle Waiting Period: 48/24/9/9 months\n 
  Pre-Existing Waiting Period: 36/36/36/36 months\n`,
};

export const recommendedCities = [
  "bangalore rural",
  "bengaluru",
  "chennai",
  "delhi",
  "faridabad",
  "gautam buddha nagar",
  "ghaziabad",
  "gurgaon",
  "hyderabad",
  "kolkata",
  "mumbai",
  "noida",
  "outside india",
  "pune",
  "thane",
  "central delhi",
  "east delhi",
  "north west delhi",
  "south delhi",
  "south west delhi",
  "west delhi",
  "north delhi"
];

export const citiesWithoutTieredNetwork = [
  "krishna",
  "hyderabad",
  "bengaluru",
  "bangalore rural",
  "chandigarh"
]

export enum PaymentTenure {
  "MONTHLY" = "monthly",
  "ANNUALY" = "annualy",
}

export const paymentTenureOptions = [
  { value: PaymentTenure.MONTHLY, label: "Monthly" },
  { value: PaymentTenure.ANNUALY, label: "Annualy" },
];
